import React from 'react';
import { Switch, Redirect, useRouteMatch } from 'react-router-dom';
import AuthorizedRouteV2 from 'commons-ui/src/permission/AuthorizedRoute';
import { PAGE_NAMES, MISCELLANEOUS_RESOURCES, ACTION } from 'constant';
import SuspiciousTransactionsList from './submodules/list';
import CreateSuspiciousTransactions from './submodules/create';

const SuspiciousTransactionsDashboard: React.FC = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<AuthorizedRouteV2
				configPageName={PAGE_NAMES.miscellaneous}
				configResourceName={MISCELLANEOUS_RESOURCES.suspiciousTransactions}
				configActionName={ACTION.listSuspiciousTransactionsRequests}
				exact
				path={`${path}/list`}
				component={SuspiciousTransactionsList}
			/>
			<AuthorizedRouteV2
				configPageName={PAGE_NAMES.miscellaneous}
				configResourceName={MISCELLANEOUS_RESOURCES.suspiciousTransactions}
				configActionName={ACTION.createSuspiciousTransactionsRequest}
				exact
				path={`${path}/create`}
				component={CreateSuspiciousTransactions}
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default SuspiciousTransactionsDashboard;
